<template>
  <b-container>
    <!-- HEADER -->
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3 class="font-weight-bold">All Bets Files</h3>
            <small class="text-muted">
              Complete betting activity exports - Daily and Monthly archives
            </small>
          </div>

          <div class="d-flex align-items-center">
            <b-button
              variant="outline-primary"
              size="sm"
              class="text-nowrap mr-1"
            >
              <feather-icon icon="FilterIcon" />
              Filter
            </b-button>
            <b-button variant="primary" size="sm" class="text-nowrap">
              <feather-icon icon="PlusIcon" />
              Generate New
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-row>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(59, 130, 246);
                background: linear-gradient(
                  rgb(239, 246, 255),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="text-muted"> Total Bets Today </span>
              <h3 class="font-weight-bolder">12,456</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(16, 185, 129);
                background: linear-gradient(
                  rgb(236, 253, 245),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted"> Total Turnover </span>
              <h3 class="font-weight-bolder">$1.87M</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(239, 68, 68);
                background: linear-gradient(
                  rgb(254, 242, 242),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">Avg Bet Size</span>
              <h3 class="font-weight-bolder">$150.12</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(132, 204, 22);
                background: linear-gradient(
                  rgb(247, 254, 231),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">Avg Bet Size</span>
              <h3 class="font-weight-bolder">24</h3>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="12" md="3" class="bg-white p-0 shadow-lg">
        <div class="archive-tabs d-flex border-bottom">
          <div
            class="tab"
            :class="{ active: tabActive === 'monthly' }"
            @click="tabActive = 'monthly'"
          >
            Monthly
          </div>
          <div
            class="tab"
            :class="{ active: tabActive === 'daily' }"
            @click="tabActive = 'daily'"
          >
            Daily
          </div>
        </div>

        <div
          v-for="month in months"
          :key="month.id"
          class="month-item"
          :class="{ active: month.id === monthActive.id }"
          @click="handleChangeMonth(month)"
        >
          <div class="font-weight-bolder">
            {{ month.label }}
          </div>
          <small class="text-muted">
            {{ month.bets }} • {{ month.turnover }}
          </small>
        </div>
      </b-col>

      <b-col cols="12" md="9" class="bg-white p-0 shadow-lg">
        <div class="d-flex justify-content-between px-2 py-1 border-bottom">
          <strong class="font-weight-bolder mb-0 text-capitalize">
            {{ monthActive.label }} - {{ tabActive }} All Bets
          </strong>

          <b-form-select
            v-model="exportType"
            :options="exportOptions"
            size="sm"
            style="width: 120px"
          />
        </div>
        <div
          v-for="(file, index) in files"
          :key="index"
          class="file-row d-flex justify-content-between align-items-center px-2 py-2"
        >
          <div class="d-flex align-items-center">
            <div class="file-icon mr-1">
              <feather-icon icon="FileTextIcon" size="18" />
            </div>

            <div>
              <div class="font-weight-semibold">
                {{ file.name }}
              </div>
              <small class="text-muted">
                {{ file.meta }}
              </small>
            </div>
          </div>

          <div>
            <b-button size="sm" variant="outline-secondary" class="mr-1">
              <feather-icon icon="EyeIcon" size="14" />
            </b-button>

            <b-button size="sm" variant="primary">
              <feather-icon icon="DownloadIcon" size="14" />
            </b-button>
          </div>
        </div>
        <div
          class="d-flex justify-content-end align-items-center px-2 py-2 border-top bg-light"
        >
          <b-button size="sm" variant="outline-secondary" class="mr-1">
            <feather-icon icon="EyeIcon" />
            Preview
          </b-button>

          <b-button size="sm" variant="primary">
            <feather-icon icon="DownloadIcon" />
            Download All
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BFormSelect,
  BButton,
  BLink,
} from "bootstrap-vue";
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BFormSelect,
    BButton,
    BLink,
  },
  data() {
    const months = [
      {
        id: 1,
        label: "January 2026",
        bets: "1,234,567 bets",
        turnover: "$18.4M turnover",
      },
      {
        id: 2,
        label: "December 2025",
        bets: "4,567,890 bets",
        turnover: "$68.2M turnover",
      },
      {
        id: 3,
        label: "November 2025",
        bets: "4,234,567 bets",
        turnover: "$63.5M turnover",
      },
      {
        id: 4,
        label: "October 2025",
        bets: "4,456,789 bets",
        turnover: "$66.8M turnover",
      },
    ];

    return {
      exportType: "CSV",
      exportOptions: ["CSV", "XLSX"],
      tabActive: "monthly",
      months,
      monthActive: months[0],
      files: [
        {
          name: "all_bets_2026-01-06_hourly_12.csv",
          meta: "Generated: Today 12:00 PM • 45.2 MB • 128,456 records",
        },
        {
          name: "all_bets_2026-01-06_hourly_11.csv",
          meta: "Generated: Today 11:00 AM • 42.1 MB • 118,234 records",
        },
        {
          name: "all_bets_2026-01-06_hourly_10.csv",
          meta: "Generated: Today 10:00 AM • 38.7 MB • 105,892 records",
        },
        {
          name: "all_bets_2026-01-06_full.xlsx",
          meta: "Generated: Today 12:00 PM • 156.4 MB • Full day export",
        },
      ],
    };
  },
  methods: {
    handleChangeMonth(month) {
      if (!month) return;
      const isActive = month.id === this.monthActive.id;
      if (isActive) return;
      const monthDetail = this.months.find((m) => m.id === month.id);
      if (monthDetail) this.monthActive = monthDetail;
    },
  },
};
</script>

<style lang="scss" scoped>
.archive-page {
  background: #f8fafc;
  min-height: 100vh;
}

.archive-tabs {
  .tab {
    flex: 1;
    text-align: center;
    padding: 18px 12px;
    cursor: pointer;
    font-weight: 600;
  }
  .active {
    border-bottom: 2px solid #3b82f6;
    color: #3b82f6;
  }
}

.month-item {
  padding: 16px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: 0.2s;
  &:hover {
    background: #f9fafb;
  }
  &.active {
    background: #eef2ff;
    border-left: 3px solid #3b82f6;
  }
}
.file-row {
  border-bottom: 1px solid #f1f1f1;

  &:hover {
    background: #fafafa;
  }
}
.file-icon {
  width: 36px;
  height: 36px;
  background: #eef2ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>